import { render, staticRenderFns } from "./GalleryOverview.vue?vue&type=template&id=68304be2&scoped=true"
import script from "./GalleryOverview.vue?vue&type=script&lang=js"
export * from "./GalleryOverview.vue?vue&type=script&lang=js"
import style0 from "./GalleryOverview.vue?vue&type=style&index=0&id=68304be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68304be2",
  null
  
)

export default component.exports